import React from 'react';
import { Popover, Button } from 'antd';
import { PlusOutlined, FolderAddOutlined, FileAddOutlined } from '@ant-design/icons';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './EntryPopover.module.scss';
import { hasRole, ROLES_CONTENT_EDITOR } from '../../constants/roles';

interface EntryPopoverProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onCreateFolder: () => void;
  onCreateFile: () => void;
  userRole?: string;
}

const EntryPopover: React.FC<EntryPopoverProps> = ({
  isOpen,
  onOpenChange,
  onCreateFolder,
  onCreateFile,
  userRole
}) => {
  const { t } = useLanguage();

  const entryPopoverContent = (
    <div className={styles.popoverContent}>
      {/* Create Folder — Admin, SuperAdmin, Editor (FolderApi) */}
      {hasRole(userRole, ...ROLES_CONTENT_EDITOR) && (
        <button
          type="button"
          className={styles.popoverItem}
          onClick={() => { onCreateFolder(); onOpenChange(false); }}
        >
          <FolderAddOutlined /> <span>{t('projectDetail.createFolder')}</span>
        </button>
      )}
      {/* Create File - Tüm yetkili roller için */}
      <button
        type="button"
        className={styles.popoverItem}
        onClick={() => { onCreateFile(); onOpenChange(false); }}
      >
        <FileAddOutlined /> <span>{t('projectDetail.createFile')}</span>
      </button>
    </div>
  );

  // Proje içinde entry ekleme — Admin, SuperAdmin, Editor
  if (!hasRole(userRole, ...ROLES_CONTENT_EDITOR)) {
    return null;
  }

  return (
    <Popover 
      content={entryPopoverContent} 
      trigger="click" 
      open={isOpen} 
      onOpenChange={onOpenChange} 
      placement="bottomRight"
      overlayClassName={styles.entryPopoverOverlay}
    >
      <Button type="primary" className={styles.uploadEntryBtn} icon={<PlusOutlined />} onClick={() => onOpenChange(true)}>
        Upload Entry
      </Button>
    </Popover>
  );
};

export default EntryPopover; 